import usePrevious from "../usePrevious";
import React from "react";

function useDialogOnEnter(currentVisibility: boolean, onEnterHandler?: () => void) {
  const prevVisibility = usePrevious(currentVisibility);

  React.useEffect(() => {
    if (currentVisibility && !prevVisibility) {
      onEnterHandler && onEnterHandler();
    }
  }, [currentVisibility, prevVisibility]);
}

export default useDialogOnEnter;
